var React = require('react');

function Pen2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 12.0756V14.9918H2.91627L11.5173 6.39077L8.60106 3.4745L0 12.0756ZM13.7726 4.13552C13.8447 4.06357 13.9019 3.97812 13.9409 3.88404C13.9799 3.78996 14 3.68911 14 3.58726C14 3.48541 13.9799 3.38456 13.9409 3.29048C13.9019 3.1964 13.8447 3.11095 13.7726 3.039L11.9528 1.21925C11.8809 1.14715 11.7954 1.08996 11.7013 1.05093C11.6073 1.01191 11.5064 0.991821 11.4046 0.991821C11.3027 0.991821 11.2019 1.01191 11.1078 1.05093C11.0137 1.08996 10.9282 1.14715 10.8563 1.21925L9.43316 2.64239L12.3494 5.55866L13.7726 4.13552Z","fill":"#FCB34E"}));
}

Pen2.defaultProps = {"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none"};

module.exports = Pen2;

Pen2.default = Pen2;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/pen-2.svg
// module id = 669
// module chunks = 0